import React from 'react';
import PropTypes from 'prop-types';

const DetailsTable = ({
  headers,
  data,
  keyMapping,
  currentPage,
  handleViewButton = () => {},
  handleClicableRow = () => {},
  handleGenerateButton =() =>{},
  handleDownloadButton=()=>{},
  handleEditClick,
  handleQuantityChange,
  handleSave,
  editRowId,
  editedQuantity,
  updateIcon,
  quantityErrors
}) => {
  console.log("editedQuantity",editedQuantity,quantityErrors);
  
  return (
    <>
      <div className="logisticstable-container">
        <table className="custom-table">
          <thead>
            <tr>
              {headers?.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((row, rowIndex) => (
              <tr key={row.po_details_id} onClick={() => handleClicableRow(row)}>
                {headers?.map((header, colIndex) => {
                  const key = keyMapping[header];

                  if (header === 'Action') {
                    return (
                      <td key={colIndex}>
                        {/* {key.map((action, actionIndex) => (
                          
                          <img
                            key={actionIndex}
                            src={
                              row.po_details_id === editRowId && action.type === 'edit'
                                ? updateIcon // Show update icon if this row is being edited
                                : action.icon
                            }
                            style={{ gap: 5, marginLeft: 10 }}
                            data-tip={action.label}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent row click
                              if (action.type === 'edit' && row.po_details_id !== editRowId) {
                                handleEditClick(row); // Enter edit mode for this row
                              } else if (action.type === 'edit' && row.po_details_id === editRowId) {
                                handleSave(row); // Save changes for this row
                              } else if (action.type === 'view') {
                                handleViewButton(row);
                              }
                              else if(action.type==='generateinvoice'){
                                handleGenerateButton(row);
                              }
                              else if(action.type==='downloadinvoice'){
                                handleDownloadButton(row);
                              }
                            }}
                            className="action-icon"
                          />
                        ))} */}
                        {key.map((action, actionIndex) => {
 
  if (action.type === 'downloadinvoice' && row.po_recvinvoice_id === 0) {
    return null; 
  }

  return (
    <img
      key={actionIndex}
      src={
        row.po_details_id === editRowId && action.type === 'edit'
          ? updateIcon 
          : action.icon
      }
      style={{ gap: 5, marginLeft: 10 }}
      data-tip={action.label}
      onClick={(e) => {
        e.stopPropagation(); // Prevent row click
        if (action.type === 'edit' && row.po_details_id !== editRowId) {
          handleEditClick(row); // Enter edit mode for this row
        } else if (action.type === 'edit' && row.po_details_id === editRowId) {
          handleSave(row); // Save changes for this row
        } else if (action.type === 'view') {
          handleViewButton(row);
        } else if (action.type === 'generateinvoice') {
          handleGenerateButton(row);
        } else if (action.type === 'downloadinvoice') {
          handleDownloadButton(row);
        }
      }}
      className="action-icon"
    />
  );
})}

                      </td>
                    );
                  }

                  
                  if (header === 'Quantity Accepted' && row.po_details_id === editRowId) {
                    return (
                      <td key={colIndex}>
                        <input
                          type="number"
                          value={editedQuantity[row.po_details_id] || ''}
                          onChange={(e) => handleQuantityChange(e, row.po_details_id)}
                          style={{
                            width: '56px',
                            height: "28px",
                            padding: "4px",
                            fontSize: "14px",
                            fontWeight: "500",
                            borderRadius: "4px",
                            border: "2px solid #7BD755",
                            paddingLeft: "10px"
                          }}
                        />
                         {quantityErrors[row.po_details_id] && (
      <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
        {quantityErrors[row.po_details_id]}
      </div>
    )}
                      </td>
                    );
                  }

                  // Render the cell content
                  return <td key={colIndex}>{row[key]}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

DetailsTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  keyMapping: PropTypes.object.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleQuantityChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  editRowId: PropTypes.number,
  editedQuantity: PropTypes.object.isRequired,
};

DetailsTable.defaultProps = {
  itemsPerPage: 10,
  isAllocation: false,
};

export default DetailsTable;
